export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/work3.aa864086.svg","height":134,"width":181,"blurWidth":0,"blurHeight":0};